var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03655 10.1968L0.394993 14.8383C0.310258 14.9231 0.263184 15.0371 0.263184 15.1574V17.7151C0.263184 17.9651 0.465081 18.167 0.7151 18.167H3.27282C3.39312 18.167 3.50819 18.12 3.59188 18.0342L3.78123 17.8459V16.1041H5.52299L5.53868 16.0884V14.3467H7.17583V12.7095H7.21872C6.33162 12.0295 5.59098 11.1759 5.03655 10.1968Z",
    fill: "#8F95AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4981 0.832947C8.31371 0.832947 5.73193 3.41368 5.73193 6.59802C5.73193 7.13467 5.82922 7.64517 5.96731 8.13788C6.5071 10.0732 8.01558 11.5827 9.94877 12.1256C10.4446 12.2648 10.9572 12.362 11.4981 12.362C14.6813 12.362 17.2631 9.78235 17.2631 6.59802C17.2631 3.41368 14.6813 0.832947 11.4981 0.832947Z",
    fill: "#8F95AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1421 5.33611C14.1421 6.10709 13.5176 6.73161 12.7466 6.73161C11.9766 6.73161 11.3511 6.10709 11.3511 5.33611C11.3511 4.56618 11.9766 3.94061 12.7466 3.94061C13.5176 3.94061 14.1421 4.56618 14.1421 5.33611Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.cf3e4258.svg";
export { ForwardRef as ReactComponent };